import React from "react";

import PropTypes from "prop-types";
import reduxForm from "redux-form/lib/reduxForm";
import Form from "reactstrap/lib/Form";
import { toast } from "react-toastify";
import Field from "redux-form/lib/Field";
import CheckboxAtom from "atoms/Checkbox";
import { FORM_LAYOUT } from "constants/layout";
import connect from "react-redux/lib/connect/connect";
import bindActionCreators from "redux/lib/bindActionCreators";
import * as AdjustmentTypesDucks from "ducks/vendors/adjustmentTypes";
import EmployeeAPIGateway from "../../../employees/gateways/employee";
import Button from "reactstrap/lib/Button";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ButtonLoaderAtom from "atoms/ButtonLoader";
import cookie from "react-cookies";
import styles from "./styles.module.scss";
import { ListGroup, ListGroupItem } from "reactstrap";

/**
 * JobTaskMappingListPage -> JobTaskMappingFilterSection -> ExportModal
 *
 * Props:
 *    - update
 */
class ExportModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.employeeAPIGateway = new EmployeeAPIGateway();
    this.selectStandardFormat = this.selectStandardFormat.bind(this);
    this.state = {
      selectedFormat: null,
      selectedButtonLoading: null,
      showAuditColumnsDropdownPDF: false,
      showAuditColumnsDropdownXLS3: false,
      adjustmentTypes: [],
      ptoPoliciesTypes: [],
      selectedColumnIds: [],
      selectedAdjustmentIds: [],
      selectedPtoPolicyIds: [],
      selectedManualColumns: {},
    };
    this.submit = this.submit.bind(this);
  }

  fetchAdjustmentTypes = (companyId) => {
    return this.props.AdjustmentTypesDucks.getAdjustmentTypes({
      company_id: companyId,
      paginated: false,
      is_active: true,
    })
      .then(() => {
        const adjustmentTypes = this.props.adjustmentTypesList?.results || [];
        this.setState({ adjustmentTypes });
      })
      .catch((error) => {
        console.error("Failed to fetch adjustment types:", error);
      });
  };

  getEmployeesPolicies = async () => {
    try {
      const ptoPoliciesTypes = await this.employeeAPIGateway.getEmployeesPolicies(
        {
          paginate: false,
          is_active: true,
        },
      );
      this.setState({ ptoPoliciesTypes });
    } catch (error) {
      console.log(error, "Error fetching pto policy list");
    }
  };

  componentDidMount() {
    const { userExtraData } = this.props;
    const promises = [];
    if (userExtraData?.company?.id) {
      promises.push(this.fetchAdjustmentTypes(userExtraData.company.id));
    }
    promises.push(this.getEmployeesPolicies());
    Promise.all(promises).then(() => {
      this.filterAndSetDefaultsFromUrl();
    });
  }

  cleanupUrl = () => {
    const currentUrl = new URL(window.location.href);

    // Remove invalid parameters
    currentUrl.searchParams.delete("adjustment_ids");
    currentUrl.searchParams.delete("pto_policy_ids");

    // Re-add only valid ones
    this.state.selectedAdjustmentIds.forEach((id) => {
      currentUrl.searchParams.append("adjustment_ids", id);
    });

    this.state.selectedPtoPolicyIds.forEach((id) => {
      currentUrl.searchParams.append("pto_policy_ids", id);
    });

    window.history.replaceState({}, "", currentUrl.toString());
  };

  filterAndSetDefaultsFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const adjustmentIdsFromUrl = urlParams
      .getAll("adjustment_ids")
      .map((id) => parseInt(id, 10));
    const ptoPolicyIdsFromUrl = urlParams
      .getAll("pto_policy_ids")
      .map((id) => parseInt(id, 10));

    const selectedAdjustmentIds = adjustmentIdsFromUrl.filter((id) =>
      this.state.adjustmentTypes.some((type) => type.id === id),
    );

    const selectedPtoPolicyIds = ptoPolicyIdsFromUrl.filter((id) =>
      this.state.ptoPoliciesTypes.some((policy) => policy.policy_id === id),
    );

    const manualColumns = {};
    const columnIds = [];

    const manualColumnKeys = [
      "include_company",
      "include_department",
      "include_team",
      "employee_title",
      "days_worked",
      "punch_in_time",
      "meal_period_time",
      "worked_time",
    ];

    manualColumnKeys.forEach((key) => {
      const value = urlParams.get(key);
      if (value === "true") {
        manualColumns[key] = true;
        columnIds.push(key);
      }
    });
    this.setState(
      {
        selectedAdjustmentIds,
        selectedPtoPolicyIds,
        selectedManualColumns: manualColumns,
        selectedColumnIds: columnIds,
      },
      () => {
        // Clean up URL if invalid IDs were filtered out
        if (
          adjustmentIdsFromUrl.length !== selectedAdjustmentIds.length ||
          ptoPolicyIdsFromUrl.length !== selectedPtoPolicyIds.length
        ) {
          this.cleanupUrl();
        }
      },
    );
  };

  componentWillMount() {
    const cookieKey = cookie.load("exportSelectedFormat");
    if (cookieKey) {
      this.setState({ selectedFormat: cookieKey });
    }
  }

  submit(data) {
    const {
      exportCsv,
      exportPdfandXls,
      exportJobPayroll,
      exportADP,
      exportADPCustom,
      dates,
      exportPayDatacsv,
      exportmileagecsv,
      exportSouthEast,
      exportJobPayrollDetail,
      exportSelectedFile,
      exportSage,
      exportiSolved,
      exportMikeRovnerCsv,
      exportDataTech,
      exportIif,
      exportIifQBD,
      exportWamsCsv,
      exportCustomTimecardCsv,
      exportMealsFlagExport,
      exportFenceFactory,
      exportPtoBalance,
      exportPaylocity,
      famousExport,
      mmchrExport,
      exportFLSA,
    } = this.props;
    const { selectedFormat, isMaxPaidTimeEnabled, maxPaidTime } = this.state;
    if (!selectedFormat)
      return toast.error("Please select the file type to export");
    if (selectedFormat === "csv") {
      return exportCsv(dates);
    } else if (selectedFormat === "dataTechcsv") {
      const format = "csv";
      return exportDataTech(format);
    } else if (selectedFormat === "flsa") {
      return exportFLSA();
    } else if (
      selectedFormat === "iif" ||
      selectedFormat === "iif2" ||
      selectedFormat === "iif_max"
    ) {
      //return exportIif(selectedFormat);
      // const maxPaidTime = this.state.isMaxPaidTimeEnabled ? this.state.maxPaidTime : null;
      return exportIif({ format: selectedFormat, max_paid_time: maxPaidTime });
    } else if (selectedFormat === "wams_csv") {
      return exportWamsCsv({
        employee_ids: this.state.selectedEmployeeIds,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        department_id: this.state.departmentId,
        department_ids: this.state.departmentIds,
        payroll_id: this.state.payrollId,
        team_id: this.state.teamId,
        team_ids: this.state.teamIds,
        ordering: this.state.ordering,
      });
    } else if (selectedFormat === "custom_timecard_csv") {
      return exportCustomTimecardCsv({
        employee_ids: this.state.selectedEmployeeIds,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        department_id: this.state.departmentId,
        department_ids: this.state.departmentIds,
        payroll_id: this.state.payrollId,
        team_id: this.state.teamId,
        team_ids: this.state.teamIds,
        ordering: this.state.ordering,
      });
    } else if (selectedFormat === "qbd-tag") {
      //return exportIif(selectedFormat);
      // const maxPaidTime = this.state.isMaxPaidTimeEnabled ? this.state.maxPaidTime : null;
      return exportIifQBD({
        format: "iif",
        max_paid_time: maxPaidTime,
        shift: true,
      });
    }
    // else if (selectedFormat === "custom_adp") {
    //   const { adpBatchId } = this.state;
    //   return exportADPCustom ({ format: "custom_adp", batch: adpBatchId });
    // }
    else if (selectedFormat === "custom_adp") {
      const { adpBatchId } = this.state;

      // ✅ Validate Batch ID: must be a positive six-digit number
      if (adpBatchId && !/^[1-9]\d{5}$/.test(adpBatchId)) {
        toast.error("Batch ID should be positive six digit number.");
        this.setState({ selectedButtonLoading: null });
        return;
      }

      return exportADPCustom({ format: "custom_adp", batch: adpBatchId });
    } else if (selectedFormat === "qbd-tag") {
      //return exportIif(selectedFormat);

      // const maxPaidTime = this.state.isMaxPaidTimeEnabled ? this.state.maxPaidTime : null;

      return exportIif({
        format: selectedFormat,
        max_paid_time: maxPaidTime,
        shift: true,
      });
    } else if (
      selectedFormat === "jobCostingXls" ||
      selectedFormat === "jobCostingPdf" ||
      selectedFormat === "jobCostingPdf2"
    ) {
      const format =
        selectedFormat === "jobCostingXls"
          ? "xlsx"
          : selectedFormat === "jobCostingPdf2"
          ? "pdf2"
          : "pdf";
      return exportJobPayroll(format, dates);
    } else if (
      selectedFormat === "jobCostingDetailXls" ||
      selectedFormat === "jobCostingDetailPdf" ||
      selectedFormat === "jobCostingDetailPdf2"
    ) {
      const format =
        selectedFormat === "jobCostingDetailXls"
          ? "xlsx"
          : selectedFormat === "jobCostingDetailPdf2"
          ? "pdf2"
          : "pdf";
      return exportJobPayrollDetail(format, dates);
    } else if (selectedFormat === "ADPXls" || selectedFormat === "ADPXls2") {
      return exportADP(selectedFormat);
    } else if (selectedFormat === "payDatacsv") {
      return exportPayDatacsv();
    } else if (selectedFormat === "mileagecsv") {
      return exportmileagecsv();
    } else if (selectedFormat === "southEastCsv") {
      return exportSouthEast();
    } else if (
      selectedFormat === "auditXls" ||
      selectedFormat === "auditXls2" ||
      selectedFormat === "auditXls3" ||
      selectedFormat === "auditPDF" ||
      selectedFormat === "adjustmentXls"
    ) {
      return exportSelectedFile(selectedFormat);
    } else if (selectedFormat === "sageExportcsv") {
      return exportSage();
    } else if (selectedFormat === "iSolvedCsv") {
      const format = "csv";
      return exportiSolved(format, dates);
    } else if (selectedFormat === "iSolvedXls") {
      const format = "xls";
      return exportiSolved(format, dates);
    } else if (selectedFormat === "mikerovnercsv") {
      const format = "csv";
      return exportMikeRovnerCsv(format, dates);
    } else if (selectedFormat === "mealsFlagExport") {
      const format = "csv";
      return exportMealsFlagExport(format, dates);
    } else if (selectedFormat === "fenceFactoryXls") {
      const format = "xlsx";
      return exportFenceFactory(format, dates);
    } else if (selectedFormat === "ptoBalanceCsv") {
      return exportPtoBalance();
    } else if (selectedFormat === "paylocityCsv") {
      return exportPaylocity();
    } else if (selectedFormat === "famousexporttxt") {
      return famousExport();
    } else if (selectedFormat === "mmchrExport") {
      const format = "csv";
      return mmchrExport(format);
    }
    return exportPdfandXls(selectedFormat, dates);
  }

  toggleAuditColumnsDropdownPDF = () => {
    this.setState((prevState) => ({
      showAuditColumnsDropdownPDF: !prevState.showAuditColumnsDropdownPDF,
      showAuditColumnsDropdownXLS3: false, // Close the other one
    }));
  };

  toggleAuditColumnsDropdownXLS3 = () => {
    this.setState((prevState) => ({
      showAuditColumnsDropdownXLS3: !prevState.showAuditColumnsDropdownXLS3,
      showAuditColumnsDropdownPDF: false, // Close the other one
    }));
  };

  handleAuditColumnChange = (column, type = "manual") => {
    if (type === "adjustment") {
      this.setState((prevState) => ({
        selectedAdjustmentIds: prevState.selectedAdjustmentIds.includes(
          column.id,
        )
          ? prevState.selectedAdjustmentIds.filter((id) => id !== column.id)
          : [...prevState.selectedAdjustmentIds, column.id],
      }));
      return;
    }

    if (type === "pto_policy") {
      this.setState((prevState) => ({
        selectedPtoPolicyIds: prevState.selectedPtoPolicyIds.includes(column.id)
          ? prevState.selectedPtoPolicyIds.filter((id) => id !== column.id)
          : [...prevState.selectedPtoPolicyIds, column.id],
      }));
      return;
    }
    this.setState((prevState) => ({
      selectedColumnIds: prevState.selectedColumnIds.includes(column.id)
        ? prevState.selectedColumnIds.filter((id) => id !== column.id)
        : [...prevState.selectedColumnIds, column.id],
      selectedManualColumns: {
        ...prevState.selectedManualColumns,
        [column.id]: !prevState.selectedManualColumns?.[column.id],
      },
    }));
  };

  applyAuditColumns = (formatType) => {
    const {
      selectedPtoPolicyIds,
      selectedAdjustmentIds,
      selectedManualColumns,
    } = this.state;

    const currentUrl = new URL(window.location.href);
    const paramsToManage = [
      "pto_policy_ids",
      "adjustment_ids",
      "employee_title",
      "days_worked",
      "punch_in_time",
      "include_company",
      "include_department",
      "include_team",
      "meal_period_time",
      "worked_time",
    ];

    paramsToManage.forEach((param) => {
      currentUrl.searchParams.delete(param);
    });

    // Add selected PTO policy IDs
    if (selectedPtoPolicyIds.length > 0) {
      selectedPtoPolicyIds.forEach((id) => {
        currentUrl.searchParams.append("pto_policy_ids", id);
      });
    }

    // Add selected adjustment IDs
    if (selectedAdjustmentIds.length > 0) {
      selectedAdjustmentIds.forEach((id) => {
        currentUrl.searchParams.append("adjustment_ids", id);
      });
    }

    // Add selected manual columns
    Object.keys(selectedManualColumns).forEach((columnId) => {
      if (selectedManualColumns[columnId]) {
        currentUrl.searchParams.set(columnId, "true");
      }
    });

    window.history.pushState({}, "", currentUrl.toString());

    // Close both dropdowns
    this.setState({
      showAuditColumnsDropdownPDF: false,
      showAuditColumnsDropdownXLS3: false,
    });
    this.selectStandardFormat(formatType);
  };

  selectStandardFormat(data) {
    this.setState({ selectedFormat: data, selectedButtonLoading: data }, () => {
      this.submit(this.state.selectedFormat);
    });
    cookie.save("exportSelectedFormat", data);
  }

  render() {
    const {
      isOpen,
      toggle,
      handleSubmit,
      userTimecardFilters,
      userExtraData,
    } = this.props;
    const { selectedFormat, selectedButtonLoading } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
        <ModalHeader toggle={toggle}>Timecard Exports</ModalHeader>
        <Form
          noValidate
          onSubmit={handleSubmit(this.submit)}
          className="mt-0"
          style={{ height: "80vh", overflow: "auto" }}
        >
          <ModalBody>
            <ListGroup flush className={styles["export-footer"]}>
              {/*employee Timecards ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0 mt-0">Employee Timecards</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("pdf")}
                    active={selectedFormat === "pdf"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT PDF{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "pdf"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("xls")}
                    active={selectedFormat === "xls"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "xls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
                <div className="w-50">
                  <div className="checkbox-custom-position">
                    <Field
                      id="correction_request"
                      type="checkbox"
                      name="correction_request"
                      label="Include Correction Requests"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("correction_request")
                      }
                    />
                  </div>
                  <div className="checkbox-custom-position">
                    <Field
                      id="days_not_worked"
                      type="checkbox"
                      name="days_not_worked"
                      label="Include Days Not Worked"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("days_not_worked")
                      }
                    />
                  </div>
                  <div className="checkbox-custom-position">
                    <Field
                      id="employee_shift_available"
                      type="checkbox"
                      name="employee_shift_available"
                      label="Include Shift Name"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("job_name")
                      }
                    />
                  </div>
                  <div className="checkbox-custom-position">
                    <Field
                      id="organization_information"
                      type="checkbox"
                      name="organization_information"
                      label="Include Org Info"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("org_info")
                      }
                    />
                  </div>
                  {userTimecardFilters && userTimecardFilters.data ? (
                    userTimecardFilters.data.timecard_decimal_view == "true" ||
                    userTimecardFilters.data.timecard_decimal_view == true ? (
                      cookie.save("isHideDecimalConversion", false)
                    ) : (
                      <div className="checkbox-custom-position">
                        <Field
                          id="disable_decimal_row"
                          type="checkbox"
                          name="disable_decimal_row"
                          label="Hide Decimal Conversion Totals"
                          component={CheckboxAtom}
                          layout={FORM_LAYOUT}
                          onChange={() =>
                            this.props.toggleEmployeeCheckbox(
                              "disable_decimal_row",
                            )
                          }
                        />
                      </div>
                    )
                  ) : null}
                  {userTimecardFilters?.data?.timecard_decimal_view ===
                    "true" && (
                    <div className="checkbox-custom-position">
                      <Field
                        id="disable_hh_mm_row"
                        type="checkbox"
                        name="disable_hh_mm_row"
                        label="Hide HH:MM Conversion Totals"
                        component={CheckboxAtom}
                        layout={FORM_LAYOUT}
                        onChange={() =>
                          this.props.toggleEmployeeCheckbox("disable_hh_mm_row")
                        }
                      />
                    </div>
                  )}

                  <div className="checkbox-custom-position">
                    <Field
                      id="include_page_number"
                      type="checkbox"
                      name="include_page_number"
                      label="Include Page Number"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("include_page_number")
                      }
                    />
                  </div>

                  <div className="checkbox-custom-position">
                    <Field
                      id="add_supervisor_signature"
                      type="checkbox"
                      name="add_supervisor_signature"
                      label="Add Supervisor Signature"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox(
                          "add_supervisor_signature",
                        )
                      }
                    />
                  </div>
                  <div className="checkbox-custom-position">
                    <Field
                      id="show_weekly_totals"
                      type="checkbox"
                      name="show_weekly_totals"
                      label="Show Weekly Totals"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      checked={this.state.show_weekly_totals} // ← CONTROLLED
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("show_weekly_totals")
                      }
                    />
                  </div>

                  <div className="checkbox-custom-position">
                    <Field
                      id="exclude_dot"
                      type="checkbox"
                      name="exclude_dot"
                      label="Hide Double OT Column"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      onChange={() =>
                        this.props.toggleEmployeeCheckbox("exclude_dot")
                      }
                    />
                  </div>
                </div>
              </ListGroupItem>

              {/*ADP ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">ADP</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("ADPXls2")}
                    active={selectedFormat === "ADPXls2"}
                    className={`${styles["export-button-custom-width"]}  float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV 2
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "ADPXls2"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("ADPXls")}
                    active={selectedFormat === "ADPXls"}
                    className={`${styles["export-button-custom-width"]}  mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "ADPXls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* Adjustment Summary */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Adjustment Summary</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("adjustmentXls")}
                    active={selectedFormat === "adjustmentXls"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "adjustmentXls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* Audit Summary */}
              <ListGroupItem>
                <span className="mr-auto">
                  <h6 className="mb-0">Audit Summary</h6>
                </span>
                <span>
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    className="float-right"
                  >
                    <Button
                      outline
                      color="primary"
                      onClick={this.toggleAuditColumnsDropdownPDF}
                      active={selectedFormat === "auditPDF"}
                      className={styles["export-button-custom-width"]}
                    >
                      <span className="mt-2 ml-1">
                        <small>
                          EXPORT PDF
                          <ButtonLoaderAtom
                            active={selectedButtonLoading === "auditPDF"}
                          />
                        </small>
                      </span>
                    </Button>

                    {this.state.showAuditColumnsDropdownPDF && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          height: "200px",
                          overflowY: "scroll",
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "15px",
                          minWidth: "250px",
                          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>Show/Hide Columns</h6>
                          <button
                            onClick={this.toggleAuditColumnsDropdownPDF}
                            style={{
                              background: "none",
                              border: "none",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </button>
                        </div>

                        {[
                          { name: "Company", id: "include_company" },
                          { name: "Department", id: "include_department" },
                          { name: "Team", id: "include_team" },
                          // Mandatory columns first - grayed out and disabled
                          {
                            name: "First Name",
                            id: "first_name",
                            mandatory: true,
                          },
                          {
                            name: "Last Name",
                            id: "last_name",
                            mandatory: true,
                          },
                          {
                            name: "Employee ID",
                            id: "employee_id",
                            mandatory: true,
                          },
                          { name: "RT", id: "rt", mandatory: true },
                          { name: "OT", id: "ot", mandatory: true },
                          { name: "DT", id: "dt", mandatory: true },
                          {
                            name: "Total Paid",
                            id: "total_paid",
                            mandatory: true,
                          },

                          // Optional columns
                          { name: "Employee Title", id: "employee_title" },
                          { name: "Days Worked", id: "days_worked" },
                          { name: "Punch-in Time", id: "punch_in_time" },
                          { name: "Meal Period Time", id: "meal_period_time" },
                          { name: "Worked Time", id: "worked_time" },
                          ...this.state.adjustmentTypes.map((type) => ({
                            name: type.name,
                            id: type.id,
                            type: "adjustment",
                          })),
                          ...this.state.ptoPoliciesTypes.map((policy) => ({
                            name: policy.policy_name,
                            id: policy.policy_id,
                            type: "pto_policy",
                          })),
                        ].map((column) => (
                          <div
                            key={column.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "8px",
                              backgroundColor: column.mandatory
                                ? "#f8f9fa"
                                : "transparent",
                              padding: "4px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={
                                column.mandatory
                                  ? true
                                  : column.type === "adjustment"
                                  ? this.state.selectedAdjustmentIds.includes(
                                      column.id,
                                    )
                                  : column.type === "pto_policy"
                                  ? this.state.selectedPtoPolicyIds.includes(
                                      column.id,
                                    )
                                  : this.state.selectedColumnIds.includes(
                                      column.id,
                                    )
                              }
                              disabled={column.mandatory}
                              onChange={() =>
                                !column.mandatory &&
                                this.handleAuditColumnChange(
                                  column,
                                  column?.type,
                                )
                              }
                              style={{
                                marginRight: "8px",
                                cursor: column.mandatory
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: column.mandatory ? 0.6 : 1,
                              }}
                            />
                            <label
                              style={{
                                margin: 0,
                                cursor: column.mandatory
                                  ? "not-allowed"
                                  : "pointer",
                                color: column.mandatory ? "#6c757d" : "inherit",
                                fontSize: "14px",
                              }}
                            >
                              {column.name}
                            </label>
                          </div>
                        ))}

                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => this.applyAuditColumns("auditPDF")}
                          style={{ marginTop: "10px", width: "100%" }}
                        >
                          Apply
                        </Button>
                      </div>
                    )}
                  </div>
                  {/* EXPORT XLS 3 - First in code (rightmost position, no mr-3 like PDF 2) */}
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    className="float-right mr-3"
                  >
                    <Button
                      outline
                      color="primary"
                      onClick={this.toggleAuditColumnsDropdownXLS3}
                      active={selectedFormat === "auditXls3"}
                      className={styles["export-button-custom-width"]}
                    >
                      <span className="mt-2 ml-1">
                        <small>
                          EXPORT XLS 3
                          <ButtonLoaderAtom
                            active={selectedButtonLoading === "auditXls3"}
                          />
                        </small>
                      </span>
                    </Button>

                    {this.state.showAuditColumnsDropdownXLS3 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          height: "200px",
                          overflowY: "scroll",
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "15px",
                          minWidth: "250px",
                          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>Show/Hide Columns</h6>
                          <button
                            onClick={this.toggleAuditColumnsDropdownXLS3}
                            style={{
                              background: "none",
                              border: "none",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </button>
                        </div>

                        {[
                          { name: "Company", id: "include_company" },
                          { name: "Department", id: "include_department" },
                          { name: "Team", id: "include_team" },
                          // Mandatory columns first - grayed out and disabled
                          {
                            name: "First Name",
                            id: "first_name",
                            mandatory: true,
                          },
                          {
                            name: "Last Name",
                            id: "last_name",
                            mandatory: true,
                          },
                          {
                            name: "Employee ID",
                            id: "employee_id",
                            mandatory: true,
                          },
                          { name: "RT", id: "rt", mandatory: true },
                          { name: "OT", id: "ot", mandatory: true },
                          { name: "DT", id: "dt", mandatory: true },
                          {
                            name: "Total Paid",
                            id: "total_paid",
                            mandatory: true,
                          },

                          // Optional columns
                          { name: "Employee Title", id: "employee_title" },
                          { name: "Days Worked", id: "days_worked" },
                          { name: "Punch-in Time", id: "punch_in_time" },
                          { name: "Meal Period Time", id: "meal_period_time" },
                          { name: "Worked Time", id: "worked_time" },
                          ...this.state.adjustmentTypes.map((type) => ({
                            name: type.name,
                            id: type.id,
                            type: "adjustment",
                          })),
                          ...this.state.ptoPoliciesTypes.map((policy) => ({
                            name: policy.policy_name,
                            id: policy.policy_id,
                            type: "pto_policy",
                          })),
                        ].map((column) => (
                          <div
                            key={column.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "8px",
                              backgroundColor: column.mandatory
                                ? "#f8f9fa"
                                : "transparent",
                              padding: "4px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={
                                column.mandatory
                                  ? true
                                  : column.type === "adjustment"
                                  ? this.state.selectedAdjustmentIds.includes(
                                      column.id,
                                    )
                                  : column.type === "pto_policy"
                                  ? this.state.selectedPtoPolicyIds.includes(
                                      column.id,
                                    )
                                  : this.state.selectedColumnIds.includes(
                                      column.id,
                                    )
                              }
                              disabled={column.mandatory}
                              onChange={() =>
                                !column.mandatory &&
                                this.handleAuditColumnChange(
                                  column,
                                  column?.type,
                                )
                              }
                              style={{
                                marginRight: "8px",
                                cursor: column.mandatory
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: column.mandatory ? 0.6 : 1,
                              }}
                            />
                            <label
                              style={{
                                margin: 0,
                                cursor: column.mandatory
                                  ? "not-allowed"
                                  : "pointer",
                                color: column.mandatory ? "#6c757d" : "inherit",
                                fontSize: "14px",
                              }}
                            >
                              {column.name}
                            </label>
                          </div>
                        ))}

                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => this.applyAuditColumns("auditXls3")}
                          style={{ marginTop: "10px", width: "100%" }}
                        >
                          Apply
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* EXPORT XLS 2 - Second in code (middle position) */}
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("auditXls2")}
                    active={selectedFormat === "auditXls2"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS 2
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "auditXls2"}
                        />
                      </small>
                    </span>
                  </Button>

                  {/* EXPORT XLS - Third in code (leftmost position) */}
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("auditXls")}
                    active={selectedFormat === "auditXls"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "auditXls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Data Tech ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Data Tech</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("dataTechcsv")}
                    active={selectedFormat === "dataTechcsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "dataTechcsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Fence Factory*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Fence Factory</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("fenceFactoryXls")}
                    active={selectedFormat === "fenceFactoryXls"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "fenceFactoryXls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*iSolved ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">iSolved</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("iSolvedXls")}
                    active={selectedFormat === "iSolvedXls"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "iSolvedXls"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("iSolvedCsv")}
                    active={selectedFormat === "iSolvedCsv"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "iSolvedCsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Jobcosting Payroll Detail ListGroupItem*/}
              <ListGroupItem>
                <span className="mr-auto">
                  <h6 className="mb-3">Job Costing Payroll Detail</h6>
                  <div className="checkbox-custom-position">
                    <Field
                      id="corrections_available"
                      type="checkbox"
                      name="corrections_available"
                      label="Include Corrections"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      checked={
                        this.props.jobCosting === "corrections_available"
                      }
                      onChange={() =>
                        this.props.toggleJobCorrectionCheckbox(
                          "corrections_available",
                        )
                      }
                    />
                    <Field
                      id="notes_available"
                      type="checkbox"
                      name="notes_available"
                      label="Include Job Notes"
                      component={CheckboxAtom}
                      layout={FORM_LAYOUT}
                      checked={this.props.jobCosting === "notes_available"}
                      onChange={() =>
                        this.props.toggleJobCorrectionCheckbox(
                          "notes_available",
                        )
                      }
                    />
                  </div>
                </span>
                <span>
                  <Button
                    outline
                    color="primary"
                    onClick={() =>
                      this.selectStandardFormat("jobCostingDetailPdf2")
                    }
                    active={selectedFormat === "jobCostingDetailPdf2"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT PDF 2
                        <ButtonLoaderAtom
                          active={
                            selectedButtonLoading === "jobCostingDetailPdf2"
                          }
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() =>
                      this.selectStandardFormat("jobCostingDetailPdf")
                    }
                    active={selectedFormat === "jobCostingDetailPdf"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT PDF{" "}
                        <ButtonLoaderAtom
                          active={
                            selectedButtonLoading === "jobCostingDetailPdf"
                          }
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() =>
                      this.selectStandardFormat("jobCostingDetailXls")
                    }
                    active={selectedFormat === "jobCostingDetailXls"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={
                            selectedButtonLoading === "jobCostingDetailXls"
                          }
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Jobcosting Payroll summary ListGroupItem*/}
              <ListGroupItem>
                <span className="mr-auto">
                  <h6 className="mb-0">Job Costing Payroll Summary</h6>
                </span>
                <span>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("jobCostingPdf2")}
                    active={selectedFormat === "jobCostingPdf2"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT PDF 2{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "jobCostingPdf2"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("jobCostingPdf")}
                    active={selectedFormat === "jobCostingPdf"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT PDF{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "jobCostingPdf"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("jobCostingXls")}
                    active={selectedFormat === "jobCostingXls"}
                    className={`${styles["export-button-custom-width"]} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT XLS{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "jobCostingXls"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* Meal Survey Export */}
              {userExtraData?.company_permissions?.meal_questionnaire && (
                <ListGroupItem>
                  <span className="w-50">
                    <h6 className="mb-0">Meal Survey Export</h6>
                  </span>
                  <span className="w-50">
                    <Button
                      outline
                      color="primary"
                      onClick={() =>
                        this.selectStandardFormat("mealsFlagExport")
                      }
                      active={selectedFormat === "mealsFlagExport"}
                      className={`${styles["export-button-custom-width"]} float-right`}
                    >
                      <span className="mt-2 ml-1">
                        <small>
                          EXPORT CSV{" "}
                          <ButtonLoaderAtom
                            active={selectedButtonLoading === "mealsFlagExport"}
                          />
                        </small>
                      </span>
                    </Button>
                  </span>
                </ListGroupItem>
              )}

              {/*Paychex ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Paychex</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("csv")}
                    active={selectedFormat === "csv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "csv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* Paylocity */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Paylocity</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("paylocityCsv")}
                    active={selectedFormat === "paylocityCsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "paylocityCsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* PTO */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">PTO Balance</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("ptoBalanceCsv")}
                    active={selectedFormat === "ptoBalanceCsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "ptoBalanceCsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Quickbooks ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Quickbooks</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("iif2")}
                    active={selectedFormat === "iif2"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT IIF 2
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "iif2"}
                        />
                      </small>
                    </span>
                  </Button>
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("iif")}
                    active={selectedFormat === "iif"}
                    className={`${styles["export-button-custom-width"]}  mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT IIF{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "iif"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*SAGE EXPORT ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">SAGE</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("sageExportcsv")}
                    active={selectedFormat === "sageExportcsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "sageExportcsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*SDP payroll ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">SDP Payroll</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("payDatacsv")}
                    active={selectedFormat === "payDatacsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "payDatacsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*SDP Reimbursement ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">SDP Reimbursement</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("mileagecsv")}
                    active={selectedFormat === "mileagecsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "mileagecsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Southeast Payroll ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Southeast Payroll</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("southEastCsv")}
                    active={selectedFormat === "southEastCsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "southEastCsv"}
                        />{" "}
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Mike Rovner ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Viewpoint</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("mikerovnercsv")}
                    active={selectedFormat === "mikerovnercsv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "mikerovnercsv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Famous Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("famousexporttxt")}
                    active={selectedFormat === "famousexporttxt"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT ASCII
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "famousexporttxt"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">MMCHR Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("mmchrExport")}
                    active={selectedFormat === "mmchrExport"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT MMCHR
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "mmchrExport"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* QBD Max Time Export ListGroupItem */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">QBD Max Time Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("iif_max")}
                    active={selectedFormat === "iif_max"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT IIF
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "iif_max"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>

                {/* Handle Max Paid Time UI */}
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "200px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.isMaxPaidTimeEnabled}
                      onChange={(e) =>
                        this.setState({
                          isMaxPaidTimeEnabled: e.target.checked,
                        })
                      }
                      style={{ marginRight: "6px" }}
                    />
                    Handle Max Paid Time
                  </label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      overflow: "hidden",
                      width: "100%",
                    }}
                  >
                    <input
                      type="number"
                      min={this.props.companyShiftHours}
                      max={24}
                      disabled={!this.state.isMaxPaidTimeEnabled}
                      value={this.state.maxPaidTime}
                      onChange={(e) =>
                        this.setState({ maxPaidTime: Number(e.target.value) })
                      }
                      style={{
                        width: "80%",
                        border: "none",
                        padding: "6px 8px",
                        textAlign: "right",
                        outline: "none",
                      }}
                    />
                    <div
                      style={{
                        backgroundColor: "#e9ecef",
                        padding: "6px 6px",
                        borderLeft: "1px solid #ccc",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        width: "20%",
                      }}
                    >
                      Hr
                    </div>
                  </div>
                </div>
              </ListGroupItem>

              {/* ADP Custom Export ListGroupItem */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">ADP Custom Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("custom_adp")}
                    active={selectedFormat === "custom_adp"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "custom_adp"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>

                {/* Batch ID Input */}
                <div style={{ marginTop: "10px", maxWidth: "200px" }}>
                  <label style={{ marginBottom: "6px", display: "block" }}>
                    Batch ID
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Batch ID"
                    value={this.state.adpBatchId || ""}
                    onChange={(e) =>
                      this.setState({ adpBatchId: e.target.value })
                    }
                    style={{
                      width: "100%",
                      padding: "6px 8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      outline: "none",
                    }}
                  />
                </div>
              </ListGroupItem>

              {/* 🔹 New ListGroupItem for QBD Tag Export */}

              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">QBD Tag Export</h6>
                </span>

                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("qbd-tag")}
                    active={selectedFormat === "qbd-tag"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT QBD
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "qbd-tag"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* WAMS CSV Timecard Export ListGroupItem */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">WAMS Timecard Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("wams_csv")}
                    active={selectedFormat === "wams_csv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "wams_csv"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/* Custom Timecard Export ListGroupItem */}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">Automate CSV</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() =>
                      this.selectStandardFormat("custom_timecard_csv")
                    }
                    active={selectedFormat === "custom_timecard_csv"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV
                        <ButtonLoaderAtom
                          active={
                            selectedButtonLoading === "custom_timecard_csv"
                          }
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*FLSA ListGroupItem*/}
              <ListGroupItem>
                <span className="w-50">
                  <h6 className="mb-0">FLSA Export</h6>
                </span>
                <span className="w-50">
                  <Button
                    outline
                    color="primary"
                    onClick={() => this.selectStandardFormat("flsa")}
                    active={selectedFormat === "flsa"}
                    className={`${styles["export-button-custom-width"]} float-right`}
                  >
                    <span className="mt-2 ml-1">
                      <small>
                        EXPORT CSV{" "}
                        <ButtonLoaderAtom
                          active={selectedButtonLoading === "flsa"}
                        />
                      </small>
                    </span>
                  </Button>
                </span>
              </ListGroupItem>

              {/*Data Tech Export
             <ListGroupItem>
                <span className="w-50"><h6 className="mb-0">Data Tech</h6></span>
                <span className="w-50">
                  <Button
                    outline color="primary"
                    onClick={() => this.selectStandardFormat('dataTechPdf')}
                    active={selectedFormat === 'dataTechPdf'}
                    className={`${styles['export-button-custom-width']} float-right`}
                  >
                    <span className="mt-2 ml-1"><small>EXPORT PDF <ButtonLoaderAtom active={selectedButtonLoading === 'dataTechPdf'} /></small></span>
                  </Button>
                  <Button
                    outline color="primary"
                    onClick={() => this.selectStandardFormat('dataTechXls')}
                    active={selectedFormat === 'dataTechXls'}
                    className={`${styles['export-button-custom-width']} mr-3 float-right`}
                  >
                    <span className="mt-2 ml-1"><small>EXPORT XLS <ButtonLoaderAtom active={selectedButtonLoading === 'dataTechXls'} /></small></span>
                  </Button>
                </span>
              </ListGroupItem>
            */}
            </ListGroup>
          </ModalBody>

          {/*<ModalFooter>
            <Button type="submit" color="secondary" size={FORM_LAYOUT.size}>
              Export Now <ButtonLoaderAtom active={submitting} />
            </Button>
          </ModalFooter>*/}
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  adjustmentTypesList: AdjustmentTypesDucks.adjustmentTypesList(state),
});

const mapDispatchToProps = (dispatch) => ({
  AdjustmentTypesDucks: bindActionCreators(AdjustmentTypesDucks, dispatch),
});

ExportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: "ExportFormModal",
    enableReinitialize: true,
  })(ExportModal),
);
